"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = require("events");
/**
 * Provides retrier service
 */
var Retrier = /** @class */ (function (_super) {
    __extends(Retrier, _super);
    /**
     * Creates a new Retrier instance
     */
    function Retrier(options) {
        var _this = _super.call(this) || this;
        _this.minDelay = options.min;
        _this.maxDelay = options.max;
        _this.initialDelay = options.initial || 0;
        _this.maxAttemptsCount = options.maxAttemptsCount || 0;
        _this.maxAttemptsTime = options.maxAttemptsTime || 0;
        _this.randomness = options.randomness || 0;
        _this.inProgress = false;
        _this.attemptNum = 0;
        _this.prevDelay = 0;
        _this.currDelay = 0;
        return _this;
    }
    Retrier.prototype.attempt = function () {
        clearTimeout(this.timeout);
        this.attemptNum++;
        this.timeout = null;
        this.emit("attempt", this);
    };
    Retrier.prototype.nextDelay = function (delayOverride) {
        if (typeof delayOverride === 'number') {
            this.prevDelay = 0;
            this.currDelay = delayOverride;
            return delayOverride;
        }
        if (this.attemptNum == 0) {
            return this.initialDelay;
        }
        if (this.attemptNum == 1) {
            this.currDelay = this.minDelay;
            return this.currDelay;
        }
        var delay = this.currDelay + this.prevDelay;
        this.prevDelay = this.currDelay;
        this.currDelay = delay;
        return delay;
    };
    Retrier.prototype.randomize = function (delay) {
        var area = delay * this.randomness;
        var corr = Math.round(Math.random() * area * 2 - area);
        return Math.max(0, delay + corr);
    };
    Retrier.prototype.scheduleAttempt = function (delayOverride) {
        var _this = this;
        if (this.maxAttemptsCount && this.attemptNum >= this.maxAttemptsCount) {
            this.cleanup();
            this.emit('failed', new Error('Maximum attempt count limit reached'));
            this.reject(new Error('Maximum attempt count reached'));
            return;
        }
        var delay = this.nextDelay(delayOverride);
        delay = this.randomize(delay);
        if (this.maxAttemptsTime && (this.startTimestamp + this.maxAttemptsTime < Date.now() + delay)) {
            this.cleanup();
            this.emit('failed', new Error('Maximum attempt time limit reached'));
            this.reject(new Error('Maximum attempt time limit reached'));
        }
        this.timeout = setTimeout(function () { return _this.attempt(); }, delay);
    };
    Retrier.prototype.cleanup = function () {
        clearTimeout(this.timeout);
        this.timeout = null;
        this.inProgress = false;
        this.attemptNum = 0;
        this.prevDelay = 0;
        this.currDelay = 0;
    };
    Retrier.prototype.start = function () {
        var _this = this;
        if (this.inProgress) {
            throw new Error('Retrier is already in progress');
        }
        this.inProgress = true;
        return new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
            _this.startTimestamp = Date.now();
            _this.scheduleAttempt(_this.initialDelay);
        });
    };
    Retrier.prototype.cancel = function () {
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
            this.inProgress = false;
            this.emit("cancelled");
            this.reject(new Error("Cancelled"));
        }
    };
    Retrier.prototype.succeeded = function (arg) {
        this.emit("succeeded", arg);
        this.resolve(arg);
    };
    Retrier.prototype.failed = function (err, nextAttemptDelayOverride) {
        if (this.timeout) {
            throw new Error("Retrier attempt is already in progress");
        }
        this.scheduleAttempt(nextAttemptDelayOverride);
    };
    Retrier.prototype.run = function (handler) {
        var _this = this;
        this.on('attempt', function () {
            handler().then(function (v) { return _this.succeeded(v); }).catch(function (e) { return _this.failed(e); });
        });
        return this.start();
    };
    return Retrier;
}(events_1.EventEmitter));
exports.Retrier = Retrier;
exports.default = Retrier;
//# sourceMappingURL=retrier.js.map